import type { MultiBrandConfig } from './types';

// Website 09 — eSIM Index / Comparison Engine. A neutral, transparent editorial
// COMPARISON property (siteType 'comparison'), NOT a checkout storefront. It
// compares the portfolio's eSIM experiences by use-case with real catalog data,
// a visible ranking methodology and an affiliate/independence disclosure.
// (index-day / index-night palettes). Name/domain PROVISIONAL.
//
// HONESTY: per strategy.md this site must be useful and transparent — NOT a fake
// review farm. No fabricated competitor prices/ratings/reviews and no
// AggregateRating. Recommendations are explained by a public methodology.
//
// DOMAIN NOTE: shares the esimsupra.com backend in preview. Needs its own
// independent domain to be credible as an index before launch.
export const esimIndex: MultiBrandConfig = {
  id: 'esim-index-comparison-engine',
  status: 'provisional',
  siteType: 'comparison',
  positioning:
    'An independent-feeling, transparent eSIM comparison and research index that ranks travel eSIM experiences by destination, price, coverage, data size, and use-case with a visible methodology — capturing comparison/research intent and routing travelers to the right plan.',
  theme: {
    mode: 'light', // neutral editorial off-white, light-first
    defaultDark: 'index-night',
    defaultLight: 'index-day',
  },
  checkoutEnabled: false,
  // Comparison engine: side-by-side comparison presentation. Presentation only.
  pricingDisplayMode: 'comparison-table',
  legacy: {
    brand: {
      name: 'eSIM Index',
      displayName: 'eSIM Index',
      tagline: 'Compare travel eSIMs in seconds',
      description:
        'Compare travel eSIM plans by destination, price per GB, coverage, validity, data size, hotspot and ease of activation. Transparent rankings, a clear methodology, and honest recommendations to help you find the right eSIM before you buy.',
      logo: '/images/assets/logo.svg',
      logoAlt: 'eSIM Index Logo',
    },
    contact: {
      // TODO(brand-email): planned dedicated inbox `hello@bestesimhub.com` (TBD) before indexed launch (R14). Shared inbox for now.
      email: 'contact@esimsupra.com',
      phone: '',
      phoneFormatted: '',
      whatsapp: '',
      address: 'Available Worldwide',
      supportHours: 'Editorial team',
    },
    website: {
      url: 'https://esimsupra.com',
      domain: 'esimsupra.com',
    },
    social: {
      facebook: '',
      twitter: '',
      instagram: '',
      youtube: '',
      telegram: '',
    },
    resources: {
      compatibilityUrl: '#',
      compatibilityLabel: 'eSIM Device Checker',
    },
    legal: {
      copyrightYear: new Date().getFullYear().toString(),
      copyrightText: `© ${new Date().getFullYear()} eSIM Index. Independent travel eSIM comparison.`,
    },
    features: {
      count180Countries: '200+ Destinations',
      uptimePerformance: 'Updated regularly',
      support247: 'Transparent methodology',
    },
    ui: {
      theme_palette_selector: true,
    },
  },
  tech: {
    analytics: {
      gtmId: 'TBD — provision per-brand GTM container ID in Google Tag Manager',
      ga4Id: 'TBD — provision per-brand GA4 measurement ID in Google Analytics',
      metaPixelId: 'TBD — provision per-brand Pixel ID in Meta Events Manager',
      googleAdsConversionId: 'TBD — provision per-brand conversion ID in Google Ads',
      googleAdsPurchaseLabel: 'TBD — provision per-brand purchase conversion label in Google Ads',
    },
    trustpilot: {
      businessUnitId: 'TBD — create Trustpilot Business Unit for bestesimhub.com',
      locale: 'en-US',
    },
    stripe: {
      // Media property — no direct sale. Suffix recorded for completeness only.
      statementDescriptorSuffix: 'INDEX',
      accountId: 'TBD — media property (checkoutEnabled: false); no Stripe account needed unless sales added',
    },
    canonical: {
      domain: 'bestesimhub.com',
      url: 'https://bestesimhub.com',
      organizationLegalName: 'TBD — register legal entity for eSIM Index',
    },
    llms: {
      tagline: 'Compare travel eSIMs in seconds',
      audience: 'Researchers comparing travel eSIM options by destination, price and coverage before buying.',
    },
  },
};

export default esimIndex;
